<template>
  <div
    class="flex items-center gap-2 text-sm font-semibold"
    :class="{
      'text-red-700': stock <= 5,
      'text-yellow-700': stock > 5 && stock <= 10,
      'text-green-700': stock > 10,
    }"
  >
    <span v-if="stock <= 5">
      {{ $t('product.stock.unavailable') }}
    </span>
    <span v-else-if="stock <= 10">
      {{ $t('product.stock.lowStock') }}
    </span>
    <span v-else>
      {{ $t('product.stock.available') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
  product: Schemas['Product']
}>()

const stock = computed(() => props.product.availableStock)
</script>
